import React from 'react';
import { useTranslation } from 'react-i18next';
import { cgvContent, resolveLegalLocale } from '../content/legal/legalContent';
import SEO from '../components/SEO';

export default function CGVPage() {
  const { i18n } = useTranslation();
  const content = cgvContent[resolveLegalLocale(i18n.language)];

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <SEO titleKey="seo.cgv.title" descriptionKey="seo.cgv.description" />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1
          className="font-heading text-3xl font-semibold text-[#1A3C34] mb-8"
          data-testid="cgv-title"
        >
          {content.title}
        </h1>

        <div className="bg-white border border-[#E2E2DF] rounded-md p-8 space-y-8 text-sm text-[#1A3C34] leading-relaxed">
          {content.sections.map((s, i) => (
            <section key={i} data-testid={`cgv-article-${i + 1}`}>
              <h2 className="font-heading text-lg font-semibold mb-3">{s.heading}</h2>
              <div dangerouslySetInnerHTML={{ __html: s.html }} />
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
